@if (useDS) {
    <div class="validation-hints">
        <span [innerHTML]="title"></span>
        <ul>
            @for (hint of validationsHints; track trackByClassName($index, hint)) {
                <li [ngClass]="hint.hintTextClass">
                    <ds-help-group>
                        <ds-help-item [type]="convertItemType(hint.className)" inverse="false" isRightAligned="false">
                            <vn-icon slot="icon" [name]="hint.hintIconClass" extraClass="ui-icon ui-icon-size-sm icon" />
                            <span slot="text" [ngClass]="hint.className">{{ hint.message }}</span>
                        </ds-help-item>
                    </ds-help-group>
                </li>
            }
        </ul>
    </div>
} @else {
    <div class="validation-hints">
        <span [innerHTML]="title"></span>
        <ul>
            @for (hint of validationsHints; track trackByClassName($index, hint)) {
                <li [ngClass]="hint.hintTextClass">
                    <vn-icon [name]="hint.hintIconClass" />
                    <span [ngClass]="hint.className">{{ hint.message }}</span>
                </li>
            }
        </ul>
    </div>
}
